export default class SwNavigationAccordion extends ContaoWebpack.Plugin {
	init () {
        this.options = {...{
        }, ...this.options};
        this.attachEventListeners();
        this.expandFirstItem();
	}

    attachEventListeners() {
        const level1Items = document.querySelectorAll('.tz-navigation-sports .level_1 > li')
        for (let item of level1Items) {
            const link = item.querySelector('a');
            if (item.classList.contains('submenu') && link) {
                link.addEventListener('click', (event) => {
                    event.preventDefault();
                });
            }

            let links = item.querySelectorAll('.level_2 a')
            for (let link of links) {
                link.addEventListener('click', (event) => {
                    event.stopPropagation();
                });
            }

            item.addEventListener('click', () => {
                const level2 = item.querySelector('.level_2');

                if (level2) {
                    if (item.classList.contains('expanded')) {
                        level2.style.maxHeight = null;
                    } else {
                        level2.style.maxHeight = level2.scrollHeight + "px";
                    }
                    item.classList.toggle('expanded');
                }
            });
        };
    }

    expandFirstItem() {
        const firstItem = document.querySelector('.tz-navigation-sports .level_1 > li:first-child');
        if (firstItem) {
            const level2 = firstItem.querySelector('.level_2');
            if (level2) {
                firstItem.classList.add('expanded');
                level2.style.maxHeight = level2.scrollHeight + "px";
            }
        }
    }
}
